'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
(function () {
    equalHeight(false);
})();
window.onresize = function () {
    equalHeight(true);
};
function equalHeight(resize) {
    let boxes = Array.from(document.querySelectorAll('[data-equal-height-box]')), titles = Array.from(document.querySelectorAll('[data-equal-height-title]')), texts = Array.from(document.querySelectorAll('[data-equal-height-text]')), allBoxHeights = [], allTitleHeights = [], allTextHeights = [], i = 0;
    if (resize === true) {
        for (i = 0; i < boxes.length; i++) {
            boxes[i].style.height = 'auto';
        }
        for (i = 0; i < titles.length; i++) {
            titles[i].style.height = 'auto';
        }
        for (i = 0; i < texts.length; i++) {
            texts[i].style.height = 'auto';
        }
    }
    for (i = 0; i < boxes.length; i++) {
        let elementHeight = boxes[i].clientHeight;
        allBoxHeights.push(elementHeight);
    }
    for (i = 0; i < titles.length; i++) {
        let elementHeight = titles[i].clientHeight;
        allTitleHeights.push(elementHeight);
    }
    for (i = 0; i < texts.length; i++) {
        let elementHeight = texts[i].clientHeight;
        allTextHeights.push(elementHeight);
    }
    for (i = 0; i < boxes.length; i++) {
        boxes[i].style.height = `${Math.max.apply(Math, allBoxHeights) * 1.20}px`;
    }
    for (i = 0; i < titles.length; i++) {
        titles[i].style.height = `${Math.max.apply(Math, allTitleHeights)}px`;
    }
    for (i = 0; i < texts.length; i++) {
        texts[i].style.height = `${Math.max.apply(Math, allTextHeights)}px`;
    }
}
exports.default = {};
